module.exports = __webpack_public_path__ + "static/Julia-Izhak-9785b7b1a33d2b308a18318df9811990.jpeg";